<template>
  <!--  页脚-->
  <div class="footerBar-box">
    <div class="footer-left">Copyright © 2025 复旦大学附属眼耳鼻喉科医院 <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备09100398号-15</a></div>
    <div class="footer-right">
      <span @click="dialogVisible = true">隐私政策</span> |
      <span @click="dialogVisible2 = true">用户协议</span>
    </div>
    <PrivacyDialog :visible.sync="dialogVisible" />
    <AgreementDialog :visible.sync="dialogVisible2"/>
  </div>
</template>

<script>
import PrivacyDialog from '@/components/modal/index.vue'
import AgreementDialog from '@/components/modal/index2.vue'
export default {
  name: "footerBar",
  components: { PrivacyDialog, AgreementDialog },
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false
    }
  },
  methods: {
    onClickRoute(path) {
      if(path) {
        window.open(path)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.footerBar-box{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(164, 18, 24, 1);
  padding: 0 220px;
  height: 54px;
  color: #fff;
  font-size: 14px;
  .footer-left{
    margin-right: 10px;
    a{
      color: #fff;
      margin-left: 15px;
    }
  }
  .footer-right{
    span{
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/footerBar.vue